var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shares && _vm.shares.length)?_c('div',{staticClass:"home-banners"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"home-banners__list"},_vm._l((_vm.shares),function(item,i){return _c('div',{key:i,staticClass:"home-banners__item"},[_c('SlideComponent',{attrs:{"data":item,"is-share":""}})],1)}),0)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }